// extracted by mini-css-extract-plugin
var _1 = "Pagination-moduleactionItemContent__Y_I68 TextListItemContent-moduleTextListItemContent__vzERa";
var _2 = "Pagination-modulearrows__MEzV9";
var _3 = "Pagination-moduledisabled___LJRJ";
var _4 = "Pagination-modulemenu__ZjXcu";
var _5 = "Pagination-modulepageSize__U6gzk Select-moduleSelect__MROu3";
var _6 = "Pagination-modulepagination__MQi06";
var _7 = "Pagination-modulepaginationSelect__oUGHm";
var _8 = "Pagination-modulepaginationSelectArrow__vO0PW";
var _9 = "Pagination-modulepaginationSelectContent__GPs7p";
var _a = "Pagination-moduletext__zAdDl";
export { _1 as "actionItemContent", _2 as "arrows", _3 as "disabled", _4 as "menu", _5 as "pageSize", _6 as "pagination", _7 as "paginationSelect", _8 as "paginationSelectArrow", _9 as "paginationSelectContent", _a as "text" }
